import React from 'react';
import { Link } from 'react-router-dom';
import { IconArrowLeft } from './Icons';

/**
 * items: array of { label, to } (last item is rendered as current, no link).
 */
const Breadcrumb = ({ items }) => {
  return (
    <nav className="ac-breadcrumb">
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <React.Fragment key={`${item.label}-${i}`}>
            {isLast ? (
              <span className="ac-breadcrumb-current">{item.label}</span>
            ) : (
              <Link to={item.to}>
                {i === 0 && <IconArrowLeft size={15} />}
                {item.label}
              </Link>
            )}
            {!isLast && <span className="ac-breadcrumb-sep">/</span>}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
